export class FindAllNoiseCatalogNumberListRequest {
    makeName?: string;
 
}